import React from 'react';
import { Chip } from '@shared/components';
import { useTheme } from '@mui/material';

interface Props {
  value: boolean;
  label: string;
}

export const BooleanChip: React.FC<Props> = ({ value, label }) => {
  const theme = useTheme();
  const { status } = theme.vars.palette.semantic;
  const tint = value ? status.positive : status.pending;
  return <Chip backgroundColor={tint.soft} textColor={tint.text} label={label} size="small" />;
};
